import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import {
  FreshdeskConversation,
  FreshdeskAttachment,
} from "./freshdeskThreadConversation"
import { IFreshdeskConversation } from "./freshdeskThreadConversation.types"

export interface IFreshdeskAttachmentRaw {
  name: string
  content_type: string
  storage_path: string
  attachment_url: string
}

export default interface IFreshdeskConversationRaw {
  [key: string]:
    string | string[] | number | boolean | null | IFreshdeskAttachmentRaw[]
}

const attachmentsFilter = (attachment: Partial<IFreshdeskAttachmentRaw>) => {
  return (
    !!attachment.name &&
    !!attachment.content_type &&
    !!attachment.storage_path &&
    !!attachment.attachment_url
  )
}

export const FreshdeskConversationParser: IParser<
  IFreshdeskConversation,
  IFreshdeskConversationRaw
> = {
  toDomain: (data: IFreshdeskConversationRaw) => {
    try {
      return new FreshdeskConversation(
        Number(data.id),
        String(data.description),
        String(data.body_html),
        Boolean(data.incoming),
        Boolean(data.private),
        dayjs(String(data.created_at)),
        data.to_emails instanceof Array
          ? data.to_emails.map((email) => String(email))
          : [""],
        (data.attachments as IFreshdeskAttachmentRaw[])
          ?.filter((attachment) => attachmentsFilter(attachment))
          .map(
            (attachment) =>
              new FreshdeskAttachment(
                attachment.name,
                attachment.content_type,
                attachment.storage_path,
                attachment.attachment_url,
              ),
          ),
        String(data.subject || ""),
        String(data.from_email ?? data.support_email ?? ""),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
